/**
 * Experiência da conta: qual "casca" a plataforma mostra (docs/specs/otto/TDD.md §5).
 *
 * - `platform`: a plataforma de sempre. Módulo que o plano não tem fica escondido.
 * - `otto`: a conta contratou só o Otto (chamadas de vídeo). Cai direto nas chamadas, e os outros módulos aparecem como
 *   vitrine, com cadeado.
 *
 * **O sinal vem da identidade do plano (`Plan.product`), nunca das chaves liberadas.** Em trial, `hasFeature` devolve
 * verdadeiro para toda chave (e o servidor também): inferir "só Otto" pela falta de Inbox faria uma conta Otto em trial
 * cair na casca completa. Por isso o produto é uma coluna explícita e `experience` vai no payload como campo **irmão** de
 * `features` (igual a `isPartnerAccount`), nunca como chave sintética dentro dele.
 *
 * Falha segura: produto ausente ou desconhecido vira `platform` (esconder a Inbox de quem a tem seria o pior erro).
 */

/** Valores de `Plan.product` (enum `PlanProduct` do schema). */
export const PLAN_PRODUCT = Object.freeze({ PLATFORM: 'PLATFORM', OTTO: 'OTTO' });

/** Valores de `Plan.billingUnit` (enum `PlanBillingUnit`): ACCOUNT cobra o plano por conta, SEAT por licença (usuário). */
export const PLAN_BILLING_UNIT = Object.freeze({ ACCOUNT: 'ACCOUNT', SEAT: 'SEAT' });

/** Valores de `experience` no payload e na web. */
export const EXPERIENCE = Object.freeze({ PLATFORM: 'platform', OTTO: 'otto' });

/** @param {unknown} value @returns {boolean} true quando `value` é um produto de plano válido. */
export function isPlanProduct(value) {
  return value === PLAN_PRODUCT.PLATFORM || value === PLAN_PRODUCT.OTTO;
}

/** @param {unknown} value @returns {boolean} true quando `value` é uma unidade de cobrança de plano válida. */
export function isPlanBillingUnit(value) {
  return value === PLAN_BILLING_UNIT.ACCOUNT || value === PLAN_BILLING_UNIT.SEAT;
}

/**
 * @param {unknown} product `Plan.product`
 * @returns {'platform' | 'otto'}
 */
export function experienceForProduct(product) {
  return product === PLAN_PRODUCT.OTTO ? EXPERIENCE.OTTO : EXPERIENCE.PLATFORM;
}
